import React from "react";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();
  return (
    <>
      <div>
        <div className="py-10 px-5 ">
          <h1 className="text-base font-semibold leading-7 text-white">
            Dashboard
          </h1>
          <h1
            onClick={() => navigate("/add-categories")}
            className="text-base leading-7 text-white cursor-pointer"
          >
            Add Category
          </h1>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
